/**
 * Mover tareas en el kanban (drag and drop y menú de estatus de la tarjeta).
 *
 * Reglas del diseño (Figma "Vista por Usuario": "Al dar drag and drop ... se
 * cambiará el responsable de la tarea, quedará en la bitácora"):
 * - Por Estatus: soltar una tarea en otra columna le cambia el estatus.
 * - Por Usuario: soltar una tarea en la columna de otro usuario la reasigna.
 * - Por Ubicación: no se mueve (la ubicación no se cambia arrastrando).
 *
 * "Vencida" no se puede elegir: es un estatus derivado de la fecha límite, no
 * un valor que se guarde. Por eso no es un destino válido.
 */

// Estatus que el usuario puede asignar a mano y valor que guarda el backend.
const STORED_STATE = {
  in_progress: 'created',
  suspended: 'suspended',
  finished: 'finished'
}

export const SETTABLE_STATES = Object.keys(STORED_STATE)

/**
 * Valor de `action_plan_tasks.state` para una clave de estatus, o null si esa
 * clave no se puede asignar (vencida, desconocida).
 */
export function storedStateFor (key) {
  return STORED_STATE[key] || null
}

/**
 * ¿Se puede soltar una tarea en esta columna de esta vista?
 */
export function isDropAllowed (viewType, columnKey) {
  if (viewType === 'status') return storedStateFor(columnKey) !== null
  return viewType === 'user'
}

/**
 * Plan de un drop: qué operación masiva hay que mandar y con qué ids. Devuelve
 * null cuando el drop no debe hacer nada (misma columna, destino inválido).
 *
 * Arrastrar una tarea que forma parte de la selección mueve toda la selección;
 * arrastrar una que no lo está mueve solo esa. Así funciona sin "Seleccionar
 * varias" y sin sorpresas cuando sí está activo.
 */
export function planDrop ({ viewType, task, fromKey, toKey, selectedIds = [], selectionActive = false }) {
  if (!task || !isDropAllowed(viewType, toKey)) return null
  if (String(fromKey) === String(toKey)) return null

  const ids = selectionActive && selectedIds.includes(task.id) ? selectedIds.slice() : [task.id]

  if (viewType === 'status') {
    return { kind: 'state', ids, value: storedStateFor(toKey) }
  }

  return { kind: 'reassign', ids, value: Number(toKey) }
}
